<div class="board-header">
  <div class="board-bar">
    <div class="dates-choicer">
      <div class="dates-block">
        <p-dropdown class="dates-dropdown" (onChange)="updateDate($event)" [options]="dates"
                    [(ngModel)]="selectedDate" optionLabel="label" placeholder="Period">
        </p-dropdown>
      </div>

      <div class="views-block">
        <p-dropdown class="dates-dropdown" (onChange)="updateView($event)" [options]="defaultViews"
                    [(ngModel)]="selectedView" optionLabel="label" placeholder="Default View">
        </p-dropdown>
      </div>
    </div>

    <div class="right-side-choiser">
      <ng-container *ngIf="selectedDate.label !== 'This Month' && selectedDate.label !== 'Last Month'">
        <div class="calendar-block dates-block">
          <div class="date-label">
            From:
          </div>
          <p-calendar [(ngModel)]="selectedStartDate" view="date" [tabindex]="-1" type="date" dateFormat="M d, yy"
                      name="startDate" placeholder="" [showIcon]="false" [ngModelOptions]="{standalone: true}"
                      styleClass="report-calendar" (ngModelChange)="dateChange()" (onShow)="blurActiveElement()">
          </p-calendar>
        </div>

        <div class="calendar-block dates-block date-to-block">
          <div class="date-label">
            To:
          </div>
          <p-calendar [(ngModel)]="selectedFinishDate" view="date" [tabindex]="-1" type="date" dateFormat="M d, yy"
                      name="finishDate" placeholder="" [showIcon]="false" [ngModelOptions]="{standalone: true}"
                      styleClass="report-calendar" (ngModelChange)="dateChange()" (onShow)="blurActiveElement()">
          </p-calendar>
        </div>
      </ng-container>

      <ng-container *ngIf="selectedDate.label === 'This Month' || selectedDate.label === 'Last Month'">
        <div class="calendar-block dates-block">
          <div class="date-label arrow-label" matRipple [matRippleCentered]="true" (click)="minusMonth()">
            <i class="pi pi-angle-left"></i>
          </div>

          <p-calendar [(ngModel)]="selectedStartDate" view="month" [tabindex]="-1" type="date" dateFormat="M, yy"
                      name="startDate" placeholder="" [showIcon]="false" [ngModelOptions]="{standalone: true}"
                      styleClass="report-calendar" (ngModelChange)="monthChange()"
                      panelStyleClass="month-changer-panel" (onShow)="blurActiveElement()">
          </p-calendar>

          <div class="date-label arrow-label" matRipple [matRippleCentered]="true" (click)="plusMonth()">
            <i class="pi pi-angle-right"></i>
          </div>
        </div>
      </ng-container>

      <div class="flex-box">

      </div>

<!--      <div class="report-button">-->
<!--        <button mat-button (click)="openReport()">Project Reports</button>-->
<!--      </div>-->

      <div class="users-block charts-chooser">
        <p-dropdown class="dates-dropdown" [options]="charts"
                    [(ngModel)]="selectedChart" placeholder="Chart" (onChange)="chartChanged()">
        </p-dropdown>
      </div>

      <div class="users-block">
        <p-multiSelect #multiSelect [defaultLabel]="'Sales Persons'" [selectedItemsLabel]="'{0} users selected'"
                       [options]="users" styleClass="users-multiselect" [optionLabel]="'name'"
                       [(ngModel)]="selectedUsers"
                       [showToggleAll]="true" (onChange)="updateManagers()" [filter]="false" [maxSelectedLabels]="1">
          <p-header (click)="showAll()">
            Show All
          </p-header>
        </p-multiSelect>
      </div>
    </div>

  </div>
</div>

<div class="reports-middle">
  <ng-container>
    <div class="sales-graph">
      <div class="router-block">
        <app-dougnuts-view *ngIf="selectedChart === 'Doughnuts'"></app-dougnuts-view>
        <app-sales-graph *ngIf="selectedChart === 'Chart'"></app-sales-graph>
        <app-bars-chart-view *ngIf="selectedChart === 'Bars'"></app-bars-chart-view>
      </div>
    </div>
    <ng-container *ngIf="selectedUsers?.length > 0">
      <div class="sales-info">
        <app-graph-total-info [usersInfo]="usersInfo" [startDate]="selectedStartDate.toDateString()"
                              [finishDate]="selectedFinishDate.toDateString()">
        </app-graph-total-info>
      </div>
    </ng-container>
  </ng-container>
</div>
